<!-- sidebar -->
<div class="sidebar">
  <!-- sidebar logo -->
  <!-- {{usersetting.theme}} -->
  <a routerLink="/" class="sidebar__logo">
    <img [src]="usersetting.theme == 'dark' ? 'assets/images/new-logo.svg': 'assets/images/new-logo.svg'" alt="" />
  </a>
  <!-- end sidebar logo -->

  <!-- sidebar user -->
  <div class="sidebar__user">
    <div class="sidebar__user-img">
      <span *ngIf="profileDetails.firstName !== '' && profileDetails.lastName !== ''; else anonymousimg">
        {{ (profileDetails.firstName | slice : 0 : 1 | uppercase) + (profileDetails.lastName | slice : 0 : 1 |
        uppercase) }}
        <!-- {{ profileDetails.lastName | slice : 0 : 1 | uppercase }} -->
      </span>
      <ng-template #anonymousimg>
        AU
      </ng-template>
    </div>

    <div class="sidebar__user-title">
      <p *ngIf="profileDetails && profileDetails.fullname !== ''; else anonymoususer">
        <span *ngIf="profileDetails.fullname.length < 8; else cut">{{ profileDetails.fullname }}</span>
        <ng-template #cut>
          {{ profileDetails.fullname | slice: 0: 9 }}...
        </ng-template>
      </p>
      <ng-template #anonymoususer>
        <p>Anonymous User</p>
      </ng-template>
      <a class="nav-link" routerLink="/edit-profile">Edit Profile</a>
    </div>

    <button mat-raised-button matTooltip="Logout" matTooltipPosition="above" matTooltipClass="custom_tooltip"
      class="sidebar__user-btn d-flex align-item-center" type="button" (click)="signOut()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 288">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path
              d="M128,16a16,16,0,0,1,32,0V128a16,16,0,0,1-32,0Zm16,272A144.22,144.22,0,0,1,0,144,142.72,142.72,0,0,1,54.08,31.68,16,16,0,0,1,76.05,55a15.81,15.81,0,0,1-2.13,1.69,112,112,0,1,0,140.16,0,16,16,0,0,1,19.84-25A142.72,142.72,0,0,1,288,144,144.22,144.22,0,0,1,144,288Z" />
          </g>
        </g>
      </svg>
    </button>
  </div>
  <!-- end sidebar user -->

  <!-- sidebar nav -->
  <ul class="sidebar__nav">
    <li class="sidebar__nav-item">
      <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <defs>
            <style>
              .dashboard {
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path
                d="M197.33,0h-160A37.38,37.38,0,0,0,0,37.33v96a37.38,37.38,0,0,0,37.33,37.34h160a37.38,37.38,0,0,0,37.34-37.34v-96A37.38,37.38,0,0,0,197.33,0Z" />
              <path
                d="M197.33,213.33h-160A37.38,37.38,0,0,0,0,250.67v224A37.38,37.38,0,0,0,37.33,512h160a37.38,37.38,0,0,0,37.34-37.33v-224A37.38,37.38,0,0,0,197.33,213.33Z" />
              <path
                d="M474.67,341.33h-160a37.38,37.38,0,0,0-37.34,37.34v96A37.38,37.38,0,0,0,314.67,512h160A37.38,37.38,0,0,0,512,474.67v-96A37.38,37.38,0,0,0,474.67,341.33Z" />
              <path
                d="M474.67,0h-160a37.38,37.38,0,0,0-37.34,37.33v224a37.38,37.38,0,0,0,37.34,37.34h160A37.38,37.38,0,0,0,512,261.33v-224A37.38,37.38,0,0,0,474.67,0Z" />
            </g>
          </g>
        </svg>
        <span>Dashboard</span></a>
    </li>

    <li class="sidebar__nav-item">
      <a routerLink="/wallet" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 416.55 479.98">
          <!-- <defs>
            <style>
              .cls-1 {
                fill-rule: evenodd;
              }
            </style>
          </defs> -->
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path class=""
                d="M416.55,302.26H316.23a19.7,19.7,0,0,0-19.6,19.6v33.53a19.68,19.68,0,0,0,19.6,19.6H416.55Zm-42.89-109.2H378c21.22,0,38.58,15.9,38.58,35.34v60.37H316.23a33.17,33.17,0,0,0-33.09,33.1v33.52a33.17,33.17,0,0,0,33.09,33.1H416.55v56.15a33.83,33.83,0,0,1-11.16,24.8A40.24,40.24,0,0,1,378,480H38.58a40.27,40.27,0,0,1-27.43-10.55A33.85,33.85,0,0,1,0,444.63v-261c6.81,5.75,16.22,9.43,28.21,9.43ZM52,179.57a93.48,93.48,0,0,1-24.4-49.71c-13.24.19-21.63,6.56-25.24,14.67a25.58,25.58,0,0,0,0,20.37c3.66,8.24,12.25,14.67,25.84,14.67ZM147.65,88a6.72,6.72,0,0,1-12,6,13.41,13.41,0,0,0-7.2-6A20.27,20.27,0,0,0,116.7,87a18.35,18.35,0,0,0-2.06.54,14.47,14.47,0,0,0-7.48,5.3,8.32,8.32,0,0,0-1.42,6.5,8.75,8.75,0,0,0,.23.88c2.14,6.46,8.76,7.59,15.38,8.72,10.59,1.8,21.18,3.61,25.9,17.8a20.11,20.11,0,0,1,.65,2.3,21.5,21.5,0,0,1-3.47,16.88A28,28,0,0,1,130,156.37c-1.09.36-2.12.66-3.06.88v9.93a6.75,6.75,0,0,1-13.49,0v-9.61a33,33,0,0,1-6.47-1.84,26.78,26.78,0,0,1-14.2-12.53,6.71,6.71,0,0,1,12-6,13.44,13.44,0,0,0,7.2,6.05,20.4,20.4,0,0,0,11.72.92q1.05-.22,2.07-.54a14.5,14.5,0,0,0,7.49-5.3,8.32,8.32,0,0,0,1.42-6.5,7,7,0,0,0-.23-.88c-2.15-6.48-8.78-7.61-15.41-8.74-10.58-1.8-21.16-3.6-25.88-17.78a22.34,22.34,0,0,1-.64-2.3A21.5,21.5,0,0,1,96,85.24a28,28,0,0,1,14.39-10.46q1.59-.52,3.06-.87V63.41a6.75,6.75,0,1,1,13.49,0V73.58a33,33,0,0,1,6.47,1.84A26.78,26.78,0,0,1,147.65,88ZM311.42,23.51a80.26,80.26,0,1,0,23.51,56.76A80.25,80.25,0,0,0,311.42,23.51Zm-119,126.9a80.94,80.94,0,0,1-24.11,29.17H72.13a80.79,80.79,0,0,1-23.25-27.45,79.78,79.78,0,0,1-8.58-29.5,1.5,1.5,0,0,0,0-.22c-.2-2.35-.31-4.72-.31-7.12a80.26,80.26,0,0,1,126.14-65.9,93.89,93.89,0,0,0,22.26,97.17q2,2,4.09,3.85Zm141.79-20.55h18a15.73,15.73,0,0,1,10.59,3.91,11.68,11.68,0,0,1,4,8.66v37.15H188.46c1.78-1.89,3.47-3.84,5.09-5.86a94,94,0,0,0,9.77-15,93.83,93.83,0,0,0,129.87-27.22c.35-.55.71-1.1,1.05-1.65ZM282.08,52.92a6.72,6.72,0,0,1-12,6,13.41,13.41,0,0,0-7.2-6A20.21,20.21,0,0,0,251.12,52a18.76,18.76,0,0,0-2.05.54,14.47,14.47,0,0,0-7.48,5.3,8.27,8.27,0,0,0-1.42,6.5c.06.29.13.59.22.88,2.15,6.45,8.77,7.58,15.39,8.71,10.59,1.8,21.18,3.61,25.9,17.8a22.38,22.38,0,0,1,.65,2.3,21.44,21.44,0,0,1-3.48,16.88,28,28,0,0,1-14.39,10.47q-1.63.54-3.06.87v9.93a6.75,6.75,0,0,1-13.49.17v-9.77a32.87,32.87,0,0,1-6.46-1.84,26.84,26.84,0,0,1-14.21-12.53,6.72,6.72,0,0,1,12-6,13.45,13.45,0,0,0,7.2,6,20.37,20.37,0,0,0,11.71.92c.7-.15,1.4-.33,2.08-.54a14.54,14.54,0,0,0,7.49-5.3,8.32,8.32,0,0,0,1.41-6.5,8.7,8.7,0,0,0-.22-.88c-2.15-6.48-8.78-7.61-15.41-8.74-10.58-1.8-21.16-3.6-25.88-17.78a22.38,22.38,0,0,1-.65-2.3,21.52,21.52,0,0,1,3.48-16.88,28,28,0,0,1,14.39-10.47q1.59-.53,3.06-.87V28.38a6.75,6.75,0,0,1,13.5,0V38.55a33,33,0,0,1,6.45,1.84,26.77,26.77,0,0,1,14.21,12.53Zm61.83,278.75a9.84,9.84,0,1,1-7-2.89A9.83,9.83,0,0,1,343.91,331.67Zm-7-16.38a23.35,23.35,0,1,1-16.5,6.84A23.34,23.34,0,0,1,337,315.29Z" />
            </g>
          </g>
        </svg>
        <span>Wallet</span>
      </a>
    </li>

    <li class="sidebar__nav-item">
      <a routerLink="/security" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360.34 428.16">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Capa_1" data-name="Capa 1">
              <path
                d="M359.89,110.21c-.51-11.27-.51-22-.51-32.77A15.09,15.09,0,0,0,344,62.08c-64,0-112.64-18.43-153.09-57.86a15.8,15.8,0,0,0-21.5,0C129,43.65,80.34,62.08,16.34,62.08A15.09,15.09,0,0,0,1,77.44c0,10.75,0,21.5-.51,32.77-2,107.52-5.12,255,174.59,316.93l5.12,1,5.12-1C364.5,365.18,361.94,218.24,359.89,110.21Zm-192,149a16.51,16.51,0,0,1-10.75,4.1h-.51a14.41,14.41,0,0,1-10.75-5.12L98.26,205.44l23-20.48,37.38,41.47,82.94-78.85,21,22.53Z" />
            </g>
          </g>
        </svg>
        <span>Security</span>
      </a>
    </li>

    <!-- <li class="sidebar__nav-item">
      <a
        class="sidebar__nav-link sidebar__nav-link--active"
        data-bs-toggle="collapse"
        href="#collapseMenu"
        role="button"
        aria-expanded="true"
        aria-controls="collapseMenu"
        ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M21.53,7.15a1,1,0,0,0-1,0L17,8.89A3,3,0,0,0,14,6H5A3,3,0,0,0,2,9v6a3,3,0,0,0,3,3h9a3,3,0,0,0,3-2.89l3.56,1.78A1,1,0,0,0,21,17a1,1,0,0,0,.53-.15A1,1,0,0,0,22,16V8A1,1,0,0,0,21.53,7.15ZM15,15a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8h9a1,1,0,0,1,1,1Zm5-.62-3-1.5V11.12l3-1.5Z"
          />
        </svg>
        <span>Videos</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M17,9.17a1,1,0,0,0-1.41,0L12,12.71,8.46,9.17a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l4.24,4.24a1,1,0,0,0,1.42,0L17,10.59A1,1,0,0,0,17,9.17Z"
          />
        </svg>
      </a>

      <ul class="collapse sidebar__menu show" id="collapseMenu">
        <li><a href="/add-item" class="active">Add item</a></li>
        <li><a href="edit-user.html">Edit user</a></li>
        <li><a href="signin.html">Sign in</a></li>
        <li><a href="signup.html">Sign up</a></li>
        <li><a href="forgot.html">Forgot password</a></li>
        <li><a href="404.html">404 page</a></li>
      </ul>
    </li> -->

    <li class="sidebar__nav-item">
      <a routerLink="/identification" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 508 460">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Solid">
              <path d="M84,390h20V372a70,70,0,0,1,33.76-59.78,46,46,0,1,1,72.48,0A70,70,0,0,1,244,372v18h20V210H84Z" />
              <circle cx="174" cy="284" r="18" />
              <path d="M174,330a42.06,42.06,0,0,0-42,42v18h84V372A42.06,42.06,0,0,0,174,330Z" />
              <path
                d="M0,140V422a38,38,0,0,0,38,38H470a38,38,0,0,0,38-38V140ZM292,404a14,14,0,0,1-14,14H70a14,14,0,0,1-14-14V196a14,14,0,0,1,14-14H278a14,14,0,0,1,14,14Zm146-6H334a14,14,0,0,1,0-28H438a14,14,0,0,1,0,28Zm0-56H334a14,14,0,0,1,0-28H438a14,14,0,0,1,0,28Zm0-56H334a14,14,0,0,1,0-28H438a14,14,0,0,1,0,28Zm0-56H334a14,14,0,0,1,0-28H438a14,14,0,0,1,0,28Z" />
              <rect x="206" width="96" height="56" rx="14" />
              <path
                d="M470,32H330V42a42.06,42.06,0,0,1-42,42H220a42.06,42.06,0,0,1-42-42V32H38A38,38,0,0,0,0,70v42H508V70A38,38,0,0,0,470,32Z" />
            </g>
          </g>
        </svg>
        <span>Identification</span>
      </a>
    </li>

    <li class="sidebar__nav-item">
      <a routerLink="/AML" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 508 460">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Solid">
              <path d="M84,390h20V372a70,70,0,0,1,33.76-59.78,46,46,0,1,1,72.48,0A70,70,0,0,1,244,372v18h20V210H84Z" />
              <circle cx="174" cy="284" r="18" />
              <path d="M174,330a42.06,42.06,0,0,0-42,42v18h84V372A42.06,42.06,0,0,0,174,330Z" />
              <path
                d="M0,140V422a38,38,0,0,0,38,38H470a38,38,0,0,0,38-38V140ZM292,404a14,14,0,0,1-14,14H70a14,14,0,0,1-14-14V196a14,14,0,0,1,14-14H278a14,14,0,0,1,14,14Zm146-6H334a14,14,0,0,1,0-28H438a14,14,0,0,1,0,28Zm0-56H334a14,14,0,0,1,0-28H438a14,14,0,0,1,0,28Zm0-56H334a14,14,0,0,1,0-28H438a14,14,0,0,1,0,28Zm0-56H334a14,14,0,0,1,0-28H438a14,14,0,0,1,0,28Z" />
              <rect x="206" width="96" height="56" rx="14" />
              <path
                d="M470,32H330V42a42.06,42.06,0,0,1-42,42H220a42.06,42.06,0,0,1-42-42V32H38A38,38,0,0,0,0,70v42H508V70A38,38,0,0,0,470,32Z" />
            </g>
          </g>
        </svg>
        <span>AML</span>
      </a>
    </li>

    <li class="sidebar__nav-item">
      <a routerLink="/bank-info" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 875 875">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <g id="surface1">
                <path
                  d="M454.17,370.86A83.36,83.36,0,0,1,574.49,255.58L717.61,398.72a48.17,48.17,0,0,0,1.14-8.1v-244l-.15-.36h.15V46.88A46.88,46.88,0,0,0,671.88,0h-625A46.88,46.88,0,0,0,0,46.88V390.62A46.88,46.88,0,0,0,46.88,437.5H515.27ZM625,46.88h31.25V93.75H625Zm-62.5,0h31.25V93.75H562.5Zm-62.5,0h31.25V93.75H500Zm-62.5,0h31.25V93.75H437.5Zm-406.25,100v-75A40.63,40.63,0,0,1,71.88,31.25h75A40.63,40.63,0,0,1,187.5,71.88v75a40.62,40.62,0,0,1-40.62,40.62h-75A40.63,40.63,0,0,1,31.25,146.88Zm78.13,212.5H46.88V328.12h62.5Zm0-93.76H46.88V234.38h62.5Zm93.74,0h-62.5V234.38h62.5Zm93.76,0h-62.5V234.38h62.5Zm93.74,93.76h-62.5V328.12h62.5Zm0-93.76h-62.5V234.38h62.5Z" />
                <path d="M72.62,468.75l16.49,42.78,111.06-42.78Z" />
                <path
                  d="M146.88,156.25a9.38,9.38,0,0,0,9.37-9.37V125H125V93.75h31.25V71.88a9.38,9.38,0,0,0-9.37-9.38h-75a9.38,9.38,0,0,0-9.38,9.38V93.75H93.75V125H62.5v21.88a9.38,9.38,0,0,0,9.38,9.37Z" />
                <path
                  d="M796.53,386.69a46.51,46.51,0,0,0,.89-35.93L750,227.73V390.62a78.26,78.26,0,0,1-6.59,31.26l27.1-10.45A46.63,46.63,0,0,0,796.53,386.69Z" />
                <path
                  d="M824.31,253l-50.62-50.72,52.87,137.32a78.11,78.11,0,0,1-44.82,101.05l-16,6.26,57.82,57.81-22.1,22.09-249-249.09a52.1,52.1,0,0,0-75.24,72.06l128.13,139.7a15.61,15.61,0,0,1,2,18.3,194.85,194.85,0,0,0,4,200.17l6.77,10.83H875V374.86A173,173,0,0,0,824.31,253Z" />
                <path d="M671.88,750H625V875H875V750Zm15.62,62.5H656.25V781.25H687.5Z" />
                <path
                  d="M286.83,468.75v.09L100.34,540.62l26.36,68.49A46.88,46.88,0,0,0,187.3,636L564.2,490.83l-20.29-22.08Z" />
              </g>
            </g>
          </g>
        </svg>
        <span>Bank Info</span>
      </a>
    </li>

    <li class="sidebar__nav-item">
      <a routerLink="/support-ticket" #targetElement routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }" class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510.71 273.94">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <g id="_13_Support_Ticket" data-name="13 Support Ticket">
                <path
                  d="M493.49,96.82c10.59-7.66,17.22-19.62,17.22-32.71V21.73A21.72,21.72,0,0,0,489,0H128.55V273.94H489a21.73,21.73,0,0,0,21.73-21.73V209.83c0-13.1-6.63-25.05-17.22-32.71-10.87-7.82-18.26-22.93-18.26-40.15s7.39-32.33,18.26-40.15ZM413.8,144.47A18.85,18.85,0,0,1,397,163.23l-8.2,1A83.82,83.82,0,0,1,384,175.92l5.17,6.48a19,19,0,0,1-1.42,25.14l-10.68,10.67a18.77,18.77,0,0,1-13.37,5.54A19.07,19.07,0,0,1,352,219.69l-6.54-5.22a83.32,83.32,0,0,1-11.74,4.86l-.94,8.22A18.88,18.88,0,0,1,314,244.29H299a18.87,18.87,0,0,1-18.76-16.76l-.94-8.2a83.94,83.94,0,0,1-11.75-4.86L261,219.64a19.06,19.06,0,0,1-11.77,4.11,18.81,18.81,0,0,1-13.37-5.54l-10.67-10.67a18.94,18.94,0,0,1-1.48-25.07l5.22-6.55a84,84,0,0,1-4.86-11.74l-8.21-.94a18.88,18.88,0,0,1-16.75-18.77v-15a18.89,18.89,0,0,1,16.77-18.77l8.19-.94A84,84,0,0,1,229,98l-5.17-6.49a19,19,0,0,1,1.44-25.13l10.67-10.68a18.76,18.76,0,0,1,13.36-5.53A19,19,0,0,1,261,54.25l6.54,5.21a84.65,84.65,0,0,1,11.75-4.86l.94-8.22A18.87,18.87,0,0,1,299,29.65h15a18.87,18.87,0,0,1,18.77,16.76l.94,8.19a84.53,84.53,0,0,1,11.74,4.86l6.49-5.17a19.11,19.11,0,0,1,11.76-4.1A18.76,18.76,0,0,1,377,55.72L387.73,66.4a18.94,18.94,0,0,1,1.48,25.07L384,98a83.94,83.94,0,0,1,4.86,11.75l8.22.94a18.87,18.87,0,0,1,16.74,18.77v15Z" />
                <path
                  d="M395.82,121.5l-15.47-1.78A73.49,73.49,0,0,0,370.91,97l9.75-12.22A8.05,8.05,0,0,0,380,74.08L369.36,63.41a8,8,0,0,0-10.67-.62l-12.22,9.74a73.47,73.47,0,0,0-22.74-9.43L322,47.63a8,8,0,0,0-8-7.12H299a8,8,0,0,0-8,7.12L289.23,63.1a73.15,73.15,0,0,0-22.74,9.44l-12.22-9.75a8.05,8.05,0,0,0-10.68.62L232.92,74.08a8,8,0,0,0-.62,10.68L242,97a73.13,73.13,0,0,0-9.43,22.74l-15.47,1.78a8,8,0,0,0-7.12,8v15a8,8,0,0,0,7.12,8l15.47,1.78A73.23,73.23,0,0,0,242,177l-9.74,12.22a8,8,0,0,0,.62,10.68l10.67,10.67a8.05,8.05,0,0,0,10.68.62l12.22-9.75a73.39,73.39,0,0,0,22.74,9.44L291,226.31a8,8,0,0,0,8,7.12h15a8,8,0,0,0,8-7.12l1.78-15.47a73.49,73.49,0,0,0,22.74-9.44l12.22,9.75a8.05,8.05,0,0,0,10.68-.62L380,199.86a8.05,8.05,0,0,0,.62-10.68L370.91,177a73.49,73.49,0,0,0,9.44-22.74l15.47-1.78a8,8,0,0,0,7.12-8v-15a8,8,0,0,0-7.12-8ZM335.1,165.56a40.48,40.48,0,1,1,0-57.19A40.49,40.49,0,0,1,335.1,165.56Z" />
                <path
                  d="M0,21.73V64.12c0,13.07,6.63,25,17.22,32.68C28.1,104.66,35.48,119.73,35.48,137s-7.38,32.3-18.26,40.17C6.63,184.8,0,196.74,0,209.82v42.39a21.73,21.73,0,0,0,21.73,21.73h96V0H21.73A21.73,21.73,0,0,0,0,21.73Zm54,7.74H94.31a7,7,0,0,1,0,13.93H54a7,7,0,1,1,0-13.93ZM54,63H94.31a7,7,0,0,1,0,13.93H54A7,7,0,1,1,54,63ZM54,96.5H94.31a7,7,0,0,1,0,13.92H54A7,7,0,1,1,54,96.5ZM54,130H94.31a7,7,0,0,1,0,13.92H54A7,7,0,1,1,54,130Zm0,33.51H94.31a7,7,0,0,1,0,13.92H54a7,7,0,1,1,0-13.92ZM54,197H94.31a7,7,0,0,1,0,13.92H54A7,7,0,1,1,54,197Zm0,33.51H94.31a7,7,0,0,1,0,13.92H54a7,7,0,1,1,0-13.92Z" />
              </g>
            </g>
          </g>
        </svg>
        <span>Support Ticket</span>
      </a>
    </li>

    <li class="sidebar__nav-item">
      <a routerLink="/notification" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" #targetElement
        class="sidebar__nav-link">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 413.6 496">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Glyph">
              <path
                d="M31.91,190.77A182,182,0,0,1,91.61,76.1a16,16,0,1,0-21.3-23.89A213.94,213.94,0,0,0,.11,187.27,16.26,16.26,0,0,0,0,189.12v.16a16,16,0,0,0,31.91,1.49Z" />
              <path
                d="M413.52,187.39C408.14,135.82,382.87,85,343.17,51.17a16,16,0,0,0-20.73,24.38c33.28,28.3,54.82,70.19,59.16,113.57a16,16,0,0,0,32,0,16.56,16.56,0,0,0-.08-1.73Z" />
              <path d="M206.56,496a63.79,63.79,0,0,0,55.1-32H151.47A63.77,63.77,0,0,0,206.56,496Z" />
              <path
                d="M380.08,351.4c-25.42-44.51-29.52-93.26-29.52-143.4A142.92,142.92,0,0,0,248.68,70.55,47.45,47.45,0,0,0,254.56,48a48,48,0,0,0-96,0,47.36,47.36,0,0,0,5.9,22.56c-59.11,18.65-101.9,75.77-101.9,142.36,0,49.23-4.56,94.84-29.52,138.49-10.24,17.9-16.29,37-4.85,56.68A47.51,47.51,0,0,0,69.7,432H343.42a47.52,47.52,0,0,0,41.52-23.91c11.34-19.57,5.51-38.53-4.86-56.69ZM206.56,64a16,16,0,1,1,16-16A16,16,0,0,1,206.56,64Z" />
            </g>
          </g>
        </svg> -->
        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
          <path
            d="M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z" />
        </svg>
        <span>Announcements</span>
        <!-- <span class="notify_count" *ngIf="unread_count > 0">{{
          unread_count
          }}</span> -->
      </a>
    </li>

    <li class="sidebar__nav-item">
      <a routerLink="/history/txn" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 458.67 458.67">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <g id="Layer_2-2" data-name="Layer 2">
                <path
                  d="M336,0H37.33A37.52,37.52,0,0,0,0,37.33v384a37.52,37.52,0,0,0,37.33,37.34H336a32.32,32.32,0,0,0,7.9-.86,37.22,37.22,0,0,0,29-33.06,64,64,0,0,1-15.58,1.92,69.34,69.34,0,0,1,0-138.67,65.78,65.78,0,0,1,16,1.92V37.33A37.51,37.51,0,0,0,336,0ZM154.67,85.33h128a16,16,0,0,1,0,32h-128a16,16,0,0,1,0-32Zm0,85.34h128a16,16,0,0,1,0,32h-128a16,16,0,0,1,0-32Zm-64,208A21.34,21.34,0,1,1,112,357.33,21.33,21.33,0,0,1,90.67,378.67Zm0-85.34A21.33,21.33,0,1,1,112,272,21.33,21.33,0,0,1,90.67,293.33Zm0-85.33A21.34,21.34,0,1,1,112,186.67,21.33,21.33,0,0,1,90.67,208Zm0-85.33A21.34,21.34,0,1,1,112,101.33,21.33,21.33,0,0,1,90.67,122.67Zm128,250.66h-64a16,16,0,0,1,0-32h64a16,16,0,1,1,0,32ZM240,288H154.67a16,16,0,1,1,0-32H240a16,16,0,0,1,0,32Z" />
                <path
                  d="M373.33,257.28a101.35,101.35,0,0,0-32,200.16c.86.13,1.72.26,2.58.37a94.26,94.26,0,0,0,13.43.86,101.33,101.33,0,0,0,16-201.39Zm-.42,167.47a64,64,0,0,1-15.58,1.92,69.34,69.34,0,0,1,0-138.67,65.78,65.78,0,0,1,16,1.92,69.21,69.21,0,0,1-.42,134.83Z" />
                <path
                  d="M378.67,394.67A16,16,0,0,1,367.35,390L346,368.65a16,16,0,0,1-4.69-11.32V314.67a16,16,0,0,1,32,0v36L390,367.35a16,16,0,0,1-11.31,27.32Z" />
              </g>
            </g>
          </g>
        </svg>
        <span>History</span>
      </a>
    </li>

    <!-- <li class="sidebar__nav-item">
      <a routerLink="/buy-crypto" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 458.67 458.67">

          <path
            d="M 25 2 C 12.264481 2 2 12.264481 2 25 C 2 37.735519 12.264481 48 25 48 C 37.735519 48 48 37.735519 48 25 C 48 12.264481 37.735519 2 25 2 z M 25 4 C 36.664481 4 46 13.335519 46 25 C 46 36.664481 36.664481 46 25 46 C 13.335519 46 4 36.664481 4 25 C 4 13.335519 13.335519 4 25 4 z M 21 10 L 21 13 L 16 13 L 16 37 L 21 37 L 21 40 L 23 40 L 23 37 L 25 37 L 25 40 L 27 40 L 27 37 C 29.3 36.9 34.800781 36.299219 34.800781 30.199219 C 34.800781 25.999219 31.199219 24.600391 29.699219 24.400391 L 29.699219 24.300781 C 30.399219 24.100781 33.900391 23.000391 33.900391 18.900391 C 33.900391 13.800391 29.1 13.1 27 13 L 27 10 L 25 10 L 25 13 L 23 13 L 23 10 L 21 10 z M 18.300781 14.900391 L 26.199219 14.900391 C 29.799219 14.900391 31.599609 16.400391 31.599609 19.400391 C 31.599609 20.600391 31.200781 21.500781 30.300781 22.300781 C 29.200781 23.200781 27.799219 23.5 26.199219 23.5 L 18.300781 23.5 L 18.300781 14.900391 z M 18.300781 25.5 L 26.199219 25.5 C 28.199219 25.5 29.800391 25.899219 30.900391 26.699219 C 32.000391 27.499219 32.5 28.699219 32.5 30.199219 C 32.5 30.599219 32.500391 31.000781 32.400391 31.300781 C 32.200391 32.400781 31.499609 33.499609 30.599609 34.099609 C 29.299609 34.999609 27.899219 34.999609 26.199219 35.099609 L 18.300781 35.099609 L 18.300781 25.5 z">
          </path>
        </svg>
        <span>Buy Crypto</span>
      </a>
    </li> -->
    <li class="sidebar__nav-item">
      <a routerLink="/buy-crypto" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">

         <i class="fab fa-bitcoin fs-4"></i>
        <span class="mx-2">Buy Crypto</span>
      </a>
    </li>
    <li class="sidebar__nav-item desktop_none">
      <a routerLink="/launchpad" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
          class="bi bi-rocket-takeoff-fill" viewBox="0 0 16 16">
          <path
            d="M12.17 9.53c2.307-2.592 3.278-4.684 3.641-6.218.21-.887.214-1.58.16-2.065a3.578 3.578 0 0 0-.108-.563 2.22 2.22 0 0 0-.078-.23V.453c-.073-.164-.168-.234-.352-.295a2.35 2.35 0 0 0-.16-.045 3.797 3.797 0 0 0-.57-.093c-.49-.044-1.19-.03-2.08.188-1.536.374-3.618 1.343-6.161 3.604l-2.4.238h-.006a2.552 2.552 0 0 0-1.524.734L.15 7.17a.512.512 0 0 0 .433.868l1.896-.271c.28-.04.592.013.955.132.232.076.437.16.655.248l.203.083c.196.816.66 1.58 1.275 2.195.613.614 1.376 1.08 2.191 1.277l.082.202c.089.218.173.424.249.657.118.363.172.676.132.956l-.271 1.9a.512.512 0 0 0 .867.433l2.382-2.386c.41-.41.668-.949.732-1.526l.24-2.408Zm.11-3.699c-.797.8-1.93.961-2.528.362-.598-.6-.436-1.733.361-2.532.798-.799 1.93-.96 2.528-.361.599.599.437 1.732-.36 2.531Z" />
          <path
            d="M5.205 10.787a7.632 7.632 0 0 0 1.804 1.352c-1.118 1.007-4.929 2.028-5.054 1.903-.126-.127.737-4.189 1.839-5.18.346.69.837 1.35 1.411 1.925Z" />
        </svg>
        <span>Launchpad</span>
      </a>
    </li>

    <li class="sidebar__nav-item desktop_none">
      <a routerLink="/market-inner" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
          class="bi bi-currency-exchange" viewBox="0 0 16 16">
          <path
            d="M0 5a5.002 5.002 0 0 0 4.027 4.905 6.46 6.46 0 0 1 .544-2.073C3.695 7.536 3.132 6.864 3 5.91h-.5v-.426h.466V5.05c0-.046 0-.093.004-.135H2.5v-.427h.511C3.236 3.24 4.213 2.5 5.681 2.5c.316 0 .59.031.819.085v.733a3.46 3.46 0 0 0-.815-.082c-.919 0-1.538.466-1.734 1.252h1.917v.427h-1.98c-.003.046-.003.097-.003.147v.422h1.983v.427H3.93c.118.602.468 1.03 1.005 1.229a6.5 6.5 0 0 1 4.97-3.113A5.002 5.002 0 0 0 0 5zm16 5.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0zm-7.75 1.322c.069.835.746 1.485 1.964 1.562V14h.54v-.62c1.259-.086 1.996-.74 1.996-1.69 0-.865-.563-1.31-1.57-1.54l-.426-.1V8.374c.54.06.884.347.966.745h.948c-.07-.804-.779-1.433-1.914-1.502V7h-.54v.629c-1.076.103-1.808.732-1.808 1.622 0 .787.544 1.288 1.45 1.493l.358.085v1.78c-.554-.08-.92-.376-1.003-.787H8.25zm1.96-1.895c-.532-.12-.82-.364-.82-.732 0-.41.311-.719.824-.809v1.54h-.005zm.622 1.044c.645.145.943.38.943.796 0 .474-.37.8-1.02.86v-1.674l.077.018z" />
        </svg>
        <span>Market</span>
      </a>
    </li>

    <li class="sidebar__nav-item desktop_none">
      <a routerLink="/fee-inner" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cash-coin"
          viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z" />
          <path
            d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z" />
          <path
            d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z" />
          <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z" />
        </svg>
        <span>Fees</span>
      </a>
    </li>

    <li class="sidebar__nav-item desktop_none">
      <a routerLink="/spot" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-graph-up"
          viewBox="0 0 16 16">
          <path fill-rule="evenodd"
            d="M0 0h1v15h15v1H0V0Zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07Z" />
        </svg>
        <span>Trade</span>
      </a>
    </li>
    <li class="sidebar__nav-item desktop_none" (click)="switchNearMalls()">
      <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar__nav-link">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-graph-up"
          viewBox="0 0 16 16">
          <path fill-rule="evenodd"
            d="M0 0h1v15h15v1H0V0Zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07Z" />
        </svg>
        <span>Utility Services</span>
      </a>
    </li>
  </ul>
  <!-- end sidebar nav -->

  <!-- sidebar copyright -->
  <div class="sidebar__copyright">
    Copy rights @ {{date.getFullYear()}}, Credbull Exchange Private Limited, All right reserved.
  </div>
  <!-- end sidebar copyright -->
</div>
<!-- end sidebar -->
